module.exports = __webpack_public_path__ + "static/assets/6a1006ee97a183722e736f8ec14896cf.gif";